export function renderNotFound(root) {
  root.innerHTML = `
    <div class="appbar"><div class="appbar-title">Not found</div></div>
    <div class="page center">
      <h1>404</h1>
      <p class="muted">That page doesn't exist.</p>
      <p><a href="/" data-link>Back to home</a></p>
    </div>
  `;
}
